// Moscents storefront enhancements (progressive; the store works without this file).

// F-004: clearing a search goes back to the full catalog. On the search results page the × button (form
// reset) and an empty search both lead to the "Clear search" link's URL (which keeps ticked filters); an
// empty search from the catalog's search box just stays on the catalog.
// Filters change the URL without reloading, so the catalog URL is built from the current address.
const msCatalogUrl = () => {
  const keep = new URLSearchParams();
  new URLSearchParams(location.search).forEach((value, key) => { if (key.startsWith('filter.')) keep.append(key, value); });
  return `/collections/all${keep.toString() ? `?${keep}` : ''}`;
};
document.addEventListener('reset', (event) => {
  if (!event.target.matches('.template-search form.search') || !new URLSearchParams(location.search).get('q')) return;
  location.href = msCatalogUrl();
}, true);
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form.matches('.template-search form.search, .ms-quick__search') || form.elements.q.value.trim()) return;
  event.preventDefault();
  location.href = msCatalogUrl();
}, true);
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ms-search-clear]');
  if (!link || event.metaKey || event.ctrlKey) return;
  event.preventDefault();
  location.href = msCatalogUrl();
});

// F-004: open the header search with ⌘K / Ctrl+K. (A bare "/" shortcut was dropped: single-key
// shortcuts need an off switch under WCAG 2.1.4.)
document.addEventListener('keydown', (event) => {
  if (event.defaultPrevented || event.isComposing || event.altKey || event.shiftKey) return;
  if (!(event.metaKey || event.ctrlKey) || event.key.toLowerCase() !== 'k') return;
  if (document.body.classList.contains('overflow-hidden')) return; // another dialog or drawer is open
  const modal = [...document.querySelectorAll('details-modal.header__search')].find((m) => m.querySelector('summary')?.offsetParent);
  if (!modal || modal.isOpen?.()) return;
  event.preventDefault();
  modal.open({ target: modal.querySelector('summary') });
});

// F-013: card size selector + Add button; adds the selected size through Dawn's Ajax cart and drawer.
if (!customElements.get('moscents-card-buy')) {
  customElements.define('moscents-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const size = event.target.closest('.ms-cardbuy__size');
        if (size) return this.select(size);
        const add = event.target.closest('[data-card-add]');
        if (add && !add.classList.contains('is-loading')) this.add(add);
      });
    }

    get selected() { return this.querySelector('.ms-cardbuy__size[aria-pressed="true"]') || this.querySelector('.ms-cardbuy__size'); }

    select(size) {
      this.querySelectorAll('.ms-cardbuy__size').forEach((b) => b.setAttribute('aria-pressed', b === size ? 'true' : 'false'));
      this.querySelector('[data-card-price]').textContent = size.dataset.price;
      this.querySelector('[data-card-meta]').textContent = size.dataset.meta;
      const add = this.querySelector('[data-card-add]');
      add.setAttribute('aria-label', `Add ${size.textContent.trim()} of ${add.dataset.title} to cart, ${size.dataset.price}`);
    }

    announce(message) {
      const status = this.querySelector('[data-card-status]');
      if (status) status.textContent = message;
    }

    async add(button) {
      const variantId = this.selected && this.selected.dataset.variantId;
      if (!variantId) return;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (cart) {
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement(button);
      }
      button.classList.add('is-loading');
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body,
        }).then((r) => r.json());
        if (response.status) throw new Error(response.description || response.message);
        if (!cart) { window.location = window.routes.cart_url; return; }
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'moscents-card-buy', productVariantId: variantId, cartData: response });
        cart.classList.remove('is-empty');
        cart.renderContents(response);
        button.classList.add('is-added');
        this.announce(`Added ${this.selected.textContent.trim()} to your bag`);
        setTimeout(() => button.classList.remove('is-added'), 1600);
      } catch (error) {
        button.classList.add('is-error');
        this.announce(error.message || 'Could not add to bag. Please try again.');
        setTimeout(() => { button.classList.remove('is-error'); this.announce(''); }, 4000);
      } finally {
        button.classList.remove('is-loading');
      }
    }
  });
}

// F-013: wishlist saved in this browser. Hearts stay hidden when storage is unavailable.
const msWishlist = (() => {
  const KEY = 'moscents-wishlist';
  let store = null;
  try { store = window.localStorage; store.setItem(KEY + '-test', '1'); store.removeItem(KEY + '-test'); } catch (e) { store = null; }
  const read = () => { try { return JSON.parse(store.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (list) => {
    try { store.setItem(KEY, JSON.stringify(list)); } catch (e) { return; }
    document.dispatchEvent(new CustomEvent('moscents:wishlist', { detail: list }));
  };
  return {
    enabled: !!store,
    list: () => (store ? read() : []),
    toggle(handle) { const list = read(); const i = list.indexOf(handle); i >= 0 ? list.splice(i, 1) : list.unshift(handle); write(list); return i < 0; },
  };
})();
window.msWishlist = msWishlist;

function msSyncHearts(root = document) {
  const saved = msWishlist.list();
  root.querySelectorAll('[data-wishlist]').forEach((button) => {
    button.hidden = !msWishlist.enabled;
    button.setAttribute('aria-pressed', saved.includes(button.dataset.wishlist) ? 'true' : 'false');
  });
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    const text = String(saved.length || '');
    if (el.textContent !== text) el.textContent = text;
    el.hidden = !msWishlist.enabled || !saved.length;
  });
}

if (msWishlist.enabled) {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist]');
    if (!button) return;
    event.preventDefault();
    msWishlist.toggle(button.dataset.wishlist);
  });
  document.addEventListener('moscents:wishlist', () => msSyncHearts());
  window.addEventListener('storage', (event) => { if (event.key === 'moscents-wishlist') document.dispatchEvent(new CustomEvent('moscents:wishlist')); });
  // Cards arrive later through filtering, search and Quick look; keep their hearts in sync.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; msSyncHearts(); });
  }).observe(document.body, { childList: true, subtree: true });
}
msSyncHearts();

// F-013: wishlist view (/collections/all?view=wishlist) shows only saved fragrances, newest first.
function msRenderWishlist() {
  const grid = document.querySelector('[data-wishlist-grid]');
  if (!grid) return;
  const saved = msWishlist.list();
  let shown = 0;
  grid.querySelectorAll('[data-wishlist-item]').forEach((item) => {
    item.hidden = !saved.includes(item.dataset.wishlistItem);
    item.style.order = String(saved.indexOf(item.dataset.wishlistItem));
    if (!item.hidden) shown++;
  });
  const empty = document.querySelector('[data-wishlist-empty]');
  if (empty) empty.hidden = shown > 0;
}
document.addEventListener('moscents:wishlist', msRenderWishlist);
msRenderWishlist();

// F-012: Share opens the device share sheet, or copies the link.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-share-url]');
  if (!button) return;
  const url = button.dataset.shareUrl;
  const label = button.querySelector('[data-share-label]');
  try {
    if (navigator.share) {
      await navigator.share({ title: button.dataset.shareTitle, url });
      return;
    }
    await navigator.clipboard.writeText(url);
    if (label) { label.textContent = 'Link copied'; setTimeout(() => (label.textContent = 'Share'), 2000); }
  } catch (e) {
    if (e && e.name === 'AbortError') return; // share sheet dismissed
    if (label) { label.textContent = 'Copy the page link to share'; setTimeout(() => (label.textContent = 'Share'), 3000); }
  }
});

// F-012: "Order today, arrives {start}–{end}", counting business days (Mon–Fri) from today.
function msAddBusinessDays(date, days) {
  const d = new Date(date);
  while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
  return d;
}
document.querySelectorAll('[data-eta]').forEach((el) => {
  const min = parseInt(el.dataset.min, 10), max = parseInt(el.dataset.max, 10);
  if (!(min > 0 && max >= min)) return;
  const fmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' });
  const now = new Date();
  el.textContent = `Order today, arrives ${fmt.format(msAddBusinessDays(now, min))} – ${fmt.format(msAddBusinessDays(now, max))}`;
  el.hidden = false;
});

// F-012: sticky add-to-cart bar on mobile once the main button scrolls out of view.
document.querySelectorAll('[data-sticky-buy]').forEach((bar) => {
  const section = bar.closest('[id^="MainProduct-"], section, .shopify-section');
  if (!section || bar.closest('quick-add-modal') || window.Shopify?.designMode) return;
  // Dawn may re-render the buy button, so look it up on every check rather than holding a reference.
  const mainButton = () => section.querySelector('product-form button[name="add"]');
  if (!mainButton()) return;
  // Animated ancestors (transforms) would break position: fixed, so the bar lives at the end of <body>.
  document.body.appendChild(bar);
  const priceEl = bar.querySelector('[data-sticky-price]');
  const syncPrice = () => {
    const price = section.querySelector('[id^="price-"] .price-item--last');
    const size = section.querySelector('variant-selects input:checked');
    if (priceEl) priceEl.textContent = [size && size.value, price && price.textContent.trim()].filter(Boolean).join(' · ');
  };
  let queued = false;
  const check = () => {
    queued = false;
    const button = mainButton();
    const below = !!button && !button.disabled && button.getBoundingClientRect().bottom < 0;
    if (below && bar.hidden) syncPrice();
    bar.hidden = !below;
    document.body.classList.toggle('ms-has-sticky-buy', below);
  };
  window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(check); } }, { passive: true });
  check();
  bar.querySelector('[data-sticky-add]').addEventListener('click', () => mainButton() && mainButton().click());
});

// F-006 / F-007: cart drawer extras — free sample picker, "Surprise me", discount codes, one-tap 1 ml adds,
// and clean-up when the cart drops below the free-sample threshold. Each request asks Shopify to return
// the re-rendered drawer so the progress bar and totals stay server-computed.
const msCart = {
  drawer: () => document.querySelector('cart-drawer'),
  // A live region outside the drawer survives re-renders, so announcements are reliable.
  live() {
    let el = document.getElementById('MsCartLive');
    if (!el) {
      el = Object.assign(document.createElement('p'), { id: 'MsCartLive', className: 'visually-hidden' });
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  },
  announce(text) {
    const el = this.live();
    el.textContent = '';
    setTimeout(() => (el.textContent = text), 50);
  },
  async request(url, payload, { focus } = {}) {
    const drawer = this.drawer();
    const body = { ...payload };
    if (drawer) body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
    const previousFill = drawer && drawer.querySelector('.ms-cartprog__bar i')?.style.getPropertyValue('--fill');
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());
    if (response.status && response.description) throw new Error(response.description);
    if (drawer && response.sections) {
      drawer.classList.toggle('is-empty', response.item_count === 0);
      drawer.renderContents(response);
      this.animateBar(previousFill);
      if (focus) setTimeout(() => drawer.querySelector(focus)?.focus(), 60);
    } else if (!drawer) {
      window.location = window.routes.cart_url;
    }
    setTimeout(() => this.cleanup(), 50);
    return response;
  },
  // The bar is re-created on every render; replay the change from the previous width.
  animateBar(previousFill) {
    const bar = this.drawer()?.querySelector('.ms-cartprog__bar i');
    if (!bar || !previousFill) return;
    const target = bar.style.getPropertyValue('--fill');
    bar.style.transition = 'none';
    bar.style.setProperty('--fill', previousFill);
    requestAnimationFrame(() => requestAnimationFrame(() => { bar.style.transition = ''; bar.style.setProperty('--fill', target); }));
  },
  appliedCodes() {
    return [...document.querySelectorAll('[data-ms-code-remove]')].map((b) => b.dataset.msCodeRemove);
  },
  message(text) {
    this.announce(text);
    setTimeout(() => document.querySelectorAll('[data-ms-code-msg]').forEach((el) => (el.textContent = text)), 80);
  },
  async cleanup(pass = 0) {
    if (this.cleaning || pass > 3) return;
    const cap = document.querySelector('[data-ms-cap-line]');
    const line = document.querySelector('[data-ms-drop-line]');
    const surprise = document.querySelector('[data-ms-drop-surprise]');
    if (!cap && !line && !surprise) return;
    this.cleaning = true;
    try {
      if (cap) await this.post(window.routes.cart_change_url + '.js', { id: cap.dataset.msCapLine, quantity: 1 });
      else if (line) await this.post(window.routes.cart_change_url + '.js', { id: line.dataset.msDropLine, quantity: 0 });
      else await this.post(window.routes.cart_update_url + '.js', { attributes: { 'Free sample': '' } });
      if (line) this.announce('Your free sample was removed because the bag is under the free-sample amount.');
    } finally {
      this.cleaning = false;
    }
    this.cleanup(pass + 1);
  },
  // Same as request() without scheduling another clean-up (cleanup() loops itself, with a cap).
  async post(url, payload) {
    const drawer = this.drawer();
    const body = { ...payload, sections: drawer ? drawer.getSectionsToRender().map((s) => s.id).join(',') : undefined };
    const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
    if (drawer && response.sections) { drawer.classList.toggle('is-empty', response.item_count === 0); drawer.renderContents(response); }
    return response;
  },
};

document.addEventListener('submit', async (event) => {
  const sampleForm = event.target.closest('[data-ms-sample-form]');
  const codeForm = event.target.closest('[data-ms-code-form]');
  if (!sampleForm && !codeForm) return;
  event.preventDefault();
  try {
    if (sampleForm) {
      const pick = event.submitter;
      if (!pick || !pick.value) return;
      const name = pick.dataset.name;
      await msCart.request(window.routes.cart_add_url + '.js', { items: [{ id: Number(pick.value), quantity: 1, properties: { _free_sample: 'yes' } }] }, { focus: '.ms-cartprog' });
      await msCart.request(window.routes.cart_update_url + '.js', { attributes: { 'Free sample': '' } });
      msCart.announce(`${name} added as your free sample.`);
    } else {
      const code = codeForm.querySelector('input').value.trim();
      if (!code) return;
      const applied = msCart.appliedCodes();
      const codes = applied.some((c) => c.toLowerCase() === code.toLowerCase()) ? applied : [...applied, code];
      const cart = await msCart.request(window.routes.cart_update_url + '.js', { discount: codes.join(',') }, { focus: '#MsCode' });
      const result = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      // Codes carry a $15 minimum (D-035), so a too-small cart is the usual reason a real code doesn't apply.
      const under = (cart.items_subtotal_price || 0) < 1500;
      msCart.message(result && result.applicable ? `${code.toUpperCase()} applied.` : under ? `${code.toUpperCase()} works on orders of $15 or more. Add a little more and try again.` : `${code.toUpperCase()} isn't valid for this cart.`);
    }
  } catch (error) {
    msCart.message(error.message || 'Something went wrong. Please try again.');
  }
});

document.addEventListener('click', async (event) => {
  const surprise = event.target.closest('[data-ms-surprise]');
  const remove = event.target.closest('[data-ms-code-remove]');
  const quick = event.target.closest('[data-ms-quick-add]');
  if (!surprise && !remove && !quick) return;
  event.preventDefault();
  try {
    if (surprise) {
      await msCart.request(window.routes.cart_update_url + '.js', { attributes: { 'Free sample': surprise.dataset.msSurprise } }, { focus: '.ms-cartprog' });
      msCart.announce(surprise.dataset.msSurprise ? "We'll add a surprise sample." : 'Choose your free sample.');
    } else if (remove) {
      const codes = msCart.appliedCodes().filter((c) => c !== remove.dataset.msCodeRemove);
      await msCart.request(window.routes.cart_update_url + '.js', { discount: codes.join(',') }, { focus: '#MsCode' });
      msCart.message(`${remove.dataset.msCodeRemove} removed.`);
    } else {
      if (quick.classList.contains('is-loading')) return;
      quick.classList.add('is-loading');
      try {
        await msCart.request(window.routes.cart_add_url + '.js', { items: [{ id: Number(quick.dataset.msQuickAdd), quantity: 1 }] }, { focus: '.drawer__heading' });
        msCart.announce('Added to your bag.');
      } finally {
        quick.classList.remove('is-loading');
      }
    }
  } catch (error) {
    msCart.message(error.message || 'Something went wrong. Please try again.');
  }
});

// Dawn's own quantity changes and removals also re-render the drawer; check for clean-up afterwards.
if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => msCart.cleanup(), 300));
}

// F-007: on product pages, lead "You may also like" with the original/alternative partner when Shopify's
// recommendations include it (the recommendations request itself can't see our pairing data).
document.querySelectorAll('product-recommendations[data-ms-partner]').forEach((el) => {
  const path = `/products/${el.dataset.msPartner}`;
  const lead = () => {
    const link = [...el.querySelectorAll('.grid__item a[href]')].find((a) => new URL(a.href, location.origin).pathname === path);
    const item = link && link.closest('.grid__item');
    if (item && item !== item.parentElement.firstElementChild) item.parentElement.prepend(item);
  };
  lead();
  new MutationObserver(lead).observe(el, { childList: true, subtree: true });
});
